export enum RoleEnum {
  BACKOFFICE_OPERATION = "backoffice-operation-perfil",
  BACKOFFICE_ADMINISTRATOR = "backoffice-administrator-perfil",
  BACKOFFICE_APPROVER_MANAGER = "backoffice-approver-manager-perfil",
  BACKOFFICE_EXTERNAL = "backoffice-external-perfil",
  FLEET_ADMIN_APPROVER = "fleet-admin-perfil",
  FLEET_ADMIN = "fleet-admin-non-approver",
  CAR_WORKSHOP = "car-workshop-perfil",
  DRIVER_PERFIL = "driver-perfil",
  DRIVER_APPROVER = "driver-approver"
}
